import { GoldenBonusSymbolTypes } from "@spawn/golden-bonus";

/**
 * This is a custom symbol configuration that is used to create a
 * lagless spin for 1x1 reels during Golden Bonus feature.
 */
export const goldenBonusLaglessSpinConfig = [
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX250,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX500,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX250,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX500,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1000,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX2500,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX250,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX500,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX250,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX250,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX500,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX25,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1000,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX10,
	GoldenBonusSymbolTypes.BonusX250,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX5,
	GoldenBonusSymbolTypes.BonusX100,
	GoldenBonusSymbolTypes.BonusX50,
	GoldenBonusSymbolTypes.BonusX2,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
	GoldenBonusSymbolTypes.BonusX1,
];
